<template>
  <div :class="$style.sectionPlan">
    <div class="section">
      <div class="container">
        <div v-html="title"></div>
        <div class="dingbeauty-switch--container">
          <el-tabs class="dingbeauty-switch" v-model="switchCost" stretch @tab-click="handleClick">
            <el-tab-pane label="年繳" name="year"></el-tab-pane>
            <el-tab-pane label="月繳" name="month"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="row swiper--pc">
          <div v-for="(item, $index) in list" :key="$index" class="col-lg-4 col-12 sectionPlan__item">
            <DingBeautyBasePlan :img="item.img" :text="item.text" :title="item.title" :money="setPlanMoney(item)" :list="item[switchCost].plan" is-show-contact :to="item.to" />
          </div>
        </div>

        <swiper ref="content-swiper" :options="swiperOption" class="swiper--mobile">
          <swiperSlide v-for="(item, $index) in list" :key="$index">
            <div class="col-lg-4 col-12 sectionPlan__item">
              <DingBeautyBasePlan :img="item.img" :text="item.text" :title="item.title" :money="setPlanMoney(item)" :list="item[switchCost].plan" is-show-contact :to="item.to" />
            </div>
          </swiperSlide>
          <div class="swiper-pagination " slot="pagination"> </div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import DingBeautyBasePlan from '@src/components/DingBeauty/DingBeautyBasePlan.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import 'slick-carousel/slick/slick.css'

export default {
  components: {
    DingBeautyBasePlan,
    swiper,
    swiperSlide,
  },

  props: {
    title: { type: String, default: '' },
  },

  data() {
    return {
      switchCost: 'year',
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
        },
      },
      list: [
        {
          img: require('@assets/dingbeauty-images/home/plan01@2.jpg'),
          text: '適合個人工作室',
          title: '客戶管理小資方案',
          year: {
            money: '$9,600',
            count: '/年',
            plan: [
              '提供公版官網',
              '單店設定',
              '管理帳號1個',
              '雲端服務',
              'iPet免費網域',
              '數據分析',
              '官方Line預約',
              '優惠券功能',
            ],
          },
          month: {
            money: '$900',
            count: '/月',
            plan: [
              '提供公版官網',
              '單店設定',
              '管理帳號1個',
              '雲端服務',
              'iPet免費網域',
              '數據分析',
              '官方Line預約',
              '優惠券功能',
            ],
          },
          to: {
            path: '/basic-plan',
            hash: '',
          },
        },
        {
          img: require('@assets/dingbeauty-images/home/plan02@2.jpg'),
          text: '適合多人以上店家',
          title: '線上預約系統方案',
          year: {
            money: '$20,000',
            count: '/年',
            plan: [
              '單店設定',
              '簡訊通知100封/月',
              '優惠券功能',
              '管理帳號5個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '分店可升級成專業',
              '官方Line預約',
              '多元付款金流串接（可收費開通）',
              '數據分析',
            ],
          },
          month: {
            money: '$2,400',
            count: '/月',
            plan: [
              '單店設定',
              '簡訊通知100封/月',
              '優惠券功能',
              '管理帳號5個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '分店可升級成專業',
              '官方Line預約',
              '多元付款金流串接（可收費開通）',
              '數據分析',
            ],
          },
          to: {
            path: '/advanced-plan',
            hash: '',
          },
        },
        {
          img: require('@assets/dingbeauty-images/home/plan03@2.jpg'),
          text: '適合有規模的品牌企業',
          title: '專業店家方案',
          year: {
            money: '$36,000',
            count: '/年',
            plan: [
              '多店設定',
              '額外新增單間分店$10,000/年（含簡訊300封、管理帳號8個）',
              '簡訊通知300封/月',
              '優惠券功能',
              '管理帳號8個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '商品POS',
              '多元付款金流串接',
              '數據分析',
            ],
          },
          month: {
            money: '$3,600',
            count: '/月',
            plan: [
              '多店設定',
              '額外新增單間分店$10,000/年（含簡訊300封、管理帳號8個）',
              '簡訊通知300封/月',
              '優惠券功能',
              '管理帳號8個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '商品POS',
              '多元付款金流串接',
              '數據分析',
            ],
          },
          to: {
            path: '/',
            hash: 'sectionContact',
          },
        },
      ],
    }
  },
  methods: {
    handleClick(tab, event) {},
    setPlanMoney(item) {
      if (this.switchCost === 'month') {
        return item.month
      } else {
        return item.year
      }
    },
  },
}
</script>

<style lang="scss" module>
.sectionPlan {
  position: relative;

  @include max-lg {
    top: 0;
  }

  :global {
    .swiper--mobile {
      .basePlan__Inner:hover {
        transform: translate(0);
      }
    }
    .swiper--pc {
      display: none;
    }
    .dingbeauty-switch--container {
      max-width: 2000px;
    }

    .plans-title {
      font-size: 23px;
      text-align: center;
      margin-bottom: 30px;
    }

    .plans-title--small {
      font-size: 14px;
      text-align: center;
      margin-bottom: 30px;
      line-height: 2;
      color: #545662;
    }

    .sectionPlan {
      &__toggle {
        margin-bottom: 10rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        @include max-lg {
          margin-bottom: 20px;
        }

        @include max-md {
          flex-direction: column;
        }
      }

      &__content {
        margin-top: 30px;
        margin-bottom: 100px;
        font-size: 14px;
        color: $color-text-2;
        line-height: 1.75;
      }
    }

    .el-tabs__nav-wrap {
      margin-left: auto;
      @include max-lg {
        margin: 0 auto;
      }
    }
    .sectionPlan__item {
      margin-bottom: 30px;
    }
  }
}

@media (min-width: 992px) {
  .sectionPlan {
    :global {
      .mobile-only {
        display: none;
      }

      .swiper--mobile {
        display: none;
      }

      .swiper--pc {
        display: flex;
      }
    }
  }
}
</style>

<style lang="scss">
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0;
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: -4px;
}

.swiper-pagination-bullet {
  border-radius: 0;
  width: 40px;
  height: 2px;
}
.swiper-pagination-bullet-active {
  background-color: #e3c192;
  height: 4px;
  transform: translateY(1px);
}
</style>
